import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiStatusCodeLookup extends Layout {
}
